import {Button, Card, Checkbox, Collapse, Divider, Popover, Radio, Spin, Typography,} from 'antd';
import Icon, {
    ArrowDownOutlined,
    CaretRightOutlined,
    CheckOutlined,
    CloseOutlined, DownOutlined, MinusOutlined,
    PlusOutlined, SettingOutlined
} from '@ant-design/icons';
import React, {useEffect, useState} from "react";
import {use} from "i18next";
import {v4} from "uuid";
import {useProject} from "../Context/ProjectContext";
import HecRasHelper from "../Helpers/HecRasHelper";
import CheckResult from "./CheckResult";

const NextLogo = ({}) => {
    return (
        <img width={24} height={24} src={'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjg4IiBoZWlnaHQ9IjY4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgb3ZlcmZsb3c9ImhpZGRlbiI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyNDcgLTI5NikiPjxwYXRoIGQ9Ik00MjYxIDY0MEM0MjYxIDQ1Ny43NDYgNDQwOC43NSAzMTAgNDU5MSAzMTAgNDc3My4yNSAzMTAgNDkyMSA0NTcuNzQ2IDQ5MjEgNjQwIDQ5MjEgODIyLjI1NCA0NzczLjI1IDk3MCA0NTkxIDk3MCA0NDA4Ljc1IDk3MCA0MjYxIDgyMi4yNTQgNDI2MSA2NDBaIiBzdHJva2U9IiMwMzU3ODEiIHN0cm9rZS13aWR0aD0iMjcuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik00NTE3LjA4IDgxMi42MDQgNDcxMC4yNiA2NDMuODI4IiBzdHJva2U9IiMwMzU3ODEiIHN0cm9rZS13aWR0aD0iNTUiIHN0cm9rZS1taXRlcmxpbWl0PSI4IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBkPSJNMCAwIDI4MC43NjQgMC4wMDAzNjA4OTIiIHN0cm9rZT0iIzAzNTc4MSIgc3Ryb2tlLXdpZHRoPSI1NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJtYXRyaXgoMC42NTc5MzYgMC43NTMwNzQgMC43NTMwNzQgLTAuNjU3OTM2IDQ1MjQuNzcgNDYzLjcwMSkiLz48L2c+PC9zdmc+'}/>
    )
}

const NextDisabledLogo = ({}) => {
    return (
        <img width={24} height={24} src={'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjg4IiBoZWlnaHQ9IjY4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgb3ZlcmZsb3c9ImhpZGRlbiI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyNDcgLTI5NikiPjxwYXRoIGQ9Ik00MjYxIDY0MEM0MjYxIDQ1Ny43NDYgNDQwOC43NSAzMTAgNDU5MSAzMTAgNDc3My4yNSAzMTAgNDkyMSA0NTcuNzQ2IDQ5MjEgNjQwIDQ5MjEgODIyLjI1NCA0NzczLjI1IDk3MCA0NTkxIDk3MCA0NDA4Ljc1IDk3MCA0MjYxIDgyMi4yNTQgNDI2MSA2NDBaIiBzdHJva2U9IiNiZGMzYzciIHN0cm9rZS13aWR0aD0iMjcuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik00NTE3LjA4IDgxMi42MDQgNDcxMC4yNiA2NDMuODI4IiBzdHJva2U9IiNiZGMzYzciIHN0cm9rZS13aWR0aD0iNTUiIHN0cm9rZS1taXRlcmxpbWl0PSI4IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBkPSJNMCAwIDI4MC43NjQgMC4wMDAzNjA4OTIiIHN0cm9rZT0iI2JkYzNjNyIgc3Ryb2tlLXdpZHRoPSI1NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJtYXRyaXgoMC42NTc5MzYgMC43NTMwNzQgMC43NTMwNzQgLTAuNjU3OTM2IDQ1MjQuNzcgNDYzLjcwMSkiLz48L2c+PC9zdmc+'}/>
    )
}

const PrevLogo = ({}) => {
    return (
        <img width={24} height={24} src={'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjg4IiBoZWlnaHQ9IjY4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgb3ZlcmZsb3c9ImhpZGRlbiI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM0MDQgLTI5NikiPjxwYXRoIGQ9Ik0zNDE4IDY0MEMzNDE4IDQ1Ny43NDYgMzU2NS43NSAzMTAgMzc0OCAzMTAgMzkzMC4yNSAzMTAgNDA3OCA0NTcuNzQ2IDQwNzggNjQwIDQwNzggODIyLjI1NCAzOTMwLjI1IDk3MCAzNzQ4IDk3MCAzNTY1Ljc1IDk3MCAzNDE4IDgyMi4yNTQgMzQxOCA2NDBaIiBzdHJva2U9IiMwMzU3ODEiIHN0cm9rZS13aWR0aD0iMjcuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik0zNzk4LjQ1IDQ2Ni4wOCAzNjI3Ljk3IDY1Ny43NjMiIHN0cm9rZT0iIzAzNTc4MSIgc3Ryb2tlLXdpZHRoPSI1NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik0wIDAgMjgwLjc2NCAwLjAwMDM2MDg5MiIgc3Ryb2tlPSIjMDM1NzgxIiBzdHJva2Utd2lkdGg9IjU1IiBzdHJva2UtbWl0ZXJsaW1pdD0iOCIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09Im1hdHJpeCgtMC43NDcyMzEgLTAuNjY0NTY1IC0wLjY2NDU2NSAwLjc0NzIzMSAzODM0LjU5IDgxMy4xOTIpIi8+PC9nPjwvc3ZnPg=='}/>
    )
}

const PrevDisabledLogo = ({}) => {
    return (
        <img width={24} height={24} src={'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjg4IiBoZWlnaHQ9IjY4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgb3ZlcmZsb3c9ImhpZGRlbiI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM0MDQgLTI5NikiPjxwYXRoIGQ9Ik0zNDE4IDY0MEMzNDE4IDQ1Ny43NDYgMzU2NS43NSAzMTAgMzc0OCAzMTAgMzkzMC4yNSAzMTAgNDA3OCA0NTcuNzQ2IDQwNzggNjQwIDQwNzggODIyLjI1NCAzOTMwLjI1IDk3MCAzNzQ4IDk3MCAzNTY1Ljc1IDk3MCAzNDE4IDgyMi4yNTQgMzQxOCA2NDBaIiBzdHJva2U9IiNiZGMzYzciIHN0cm9rZS13aWR0aD0iMjcuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik0zNzk4LjQ1IDQ2Ni4wOCAzNjI3Ljk3IDY1Ny43NjMiIHN0cm9rZT0iI2JkYzNjNyIgc3Ryb2tlLXdpZHRoPSI1NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjgiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGQ9Ik0wIDAgMjgwLjc2NCAwLjAwMDM2MDg5MiIgc3Ryb2tlPSIjYmRjM2M3IiBzdHJva2Utd2lkdGg9IjU1IiBzdHJva2UtbWl0ZXJsaW1pdD0iOCIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09Im1hdHJpeCgtMC43NDcyMzEgLTAuNjY0NTY1IC0wLjY2NDU2NSAwLjc0NzIzMSAzODM0LjU5IDgxMy4xOTIpIi8+PC9nPjwvc3ZnPg=='}/>
    )
}


const { Panel } = Collapse;

export const OPS_STATUS = {
    NOT_CHECK: 0,
    CHECKING: 1,
    COMPLETED: 2,
    ERROR: 3,
}

export default function OperationManager({operations, id, selected, summaryPanel, showKey, settings, type, toolbox, toolboxLeft, projectSelectorComponent, projectSelectorTitle, activeOperation}) {
    const {sort, setSort, isLibraryProject, isFloadwayPlan, operationTitle, setOperationTitle, tabComponent, internalSelectedId, internalRiverKey, comparisonBaseRiverKey, comparisonCmpRiverKey, comparisonBaseId, comparisonCmpId} = useProject()
    const [key, setKey] = useState(v4())
    const [expand, setExpand] = useState([])
    const [selectedIndex, setSelectedIndex] = useState({
        x: -2,
        y: -2
    })
    const [_operations, set_operations] = useState([])
    const [indexData, setIndexData] = useState({
        firstError: {x: -1, y: -1},
        lastError: {x: -1, y: -1},
    })

    const update = () => {
        if(operations) {
            set_operations(operations)
            setKey(key)
        }
    }

    const checkType = (type) => {
        if(!type)
            return true

        if(type === 'library' && !isLibraryProject())
        {
            return false
        }
        else if(type === 'floadway' && !isFloadwayPlan()){
            return false
        }

        return true
    }

    useEffect(() => {
        update()
    }, [operations,internalSelectedId, internalRiverKey, comparisonBaseRiverKey, comparisonCmpRiverKey, comparisonBaseId, comparisonCmpId])

    useEffect(() => {
        if(selected && selected.x && selected.y) {
            setSelectedIndex(selected)
        }
    }, [selected])

    const onCheckedChanged = (title, childTitle, val) => {
        const ops = [..._operations]
        ops.forEach(x => {
            if(x.title === title) {
                x.children.forEach(y => {
                    if(y.title === childTitle) {
                        y.enable = val
                    }
                })
            }
        })
        set_operations(ops)
    }

    const onCheckAll = (title, val) => {
        const ops = [..._operations]
        ops.forEach(x => {
            if(x.title === title) {
                x.children.forEach(y => {
                    y.enable = val
                })
            }
        })
        set_operations(ops)
    }

    const getAllTime = () => {
        let time = 0;
        _operations.forEach(item => {
            item.children.forEach(child => {
                time += child.time
            })
        })
        return time.toFixed(1);
    }

    const renderOperations = () => {
        const errorColor = '#ee5253'
        const successColor = '#27ae60'
        const normalColor = '#0f0f0f'
        const selectedColor = '#01a3a4'

        const renderHeader = (op, idx) => {

            const getHeaderColor = (completed, showIndicator, idx) => {
                if(completed && showIndicator)
                    return errorColor
                else if(completed && !showIndicator)
                    return successColor
            }

            const checked = op.children.filter(item => item.enable).length === op.children.length;
            const checking = op.children.filter(item => item.enable && item.status === OPS_STATUS.CHECKING).length > 0
            const completed = op.children.filter(item => item.status === OPS_STATUS.COMPLETED).length > 0
            const showIndicator = op.children.filter(item => item.showIndicator && item.showIndicator({data: item.result})).length > 0
            const intermediate = op.children.filter(item => item.enable).length > 0;

            let time = 0;
            op.children.forEach(x => x.time && (time += x.time))

            return (
                <div
                    onClick={() => {
                        if(!checkType(op.type))
                            return

                        const key = op.title
                        if(expand.find(x => x === key))
                            setExpand(expand.filter(x => x !== key))
                        else
                            setExpand([...expand, key])
                    }}
                    style={{display: 'flex', alignItems: 'center', gap: 8, padding: 4, backgroundColor: 'rgb(230, 238, 242)'}}
                >
                    <div onClick={(e) => {e.stopPropagation()}}>
                        <Checkbox
                            disabled={checking || !checkType(op.type) || !id}
                            checked={checked}
                            indeterminate={!checked && intermediate}
                            onChange={(e) => {
                                onCheckAll(op.title, e.target.checked)
                            }}
                        />
                    </div>
                    <span
                        style={{
                            color: getHeaderColor(completed, showIndicator, idx),
                            fontWeight: selectedIndex.x === idx ? 'bold' : ''
                        }}
                    >
                        {`${op.title}`}
                    </span>
                    {
                        completed && !showIndicator && (
                            <span style={{color: successColor}}>
                                ({time.toFixed(1)} s)
                            </span>
                        )
                    }
                    {
                        completed && showIndicator && (
                            <div style={{color: errorColor, display: 'flex', alignItems: 'center', gap: 4}}>
                                ({time.toFixed(1)} s)
                            </div>
                        )
                    }
                </div>
            )
        }

        return _operations.map((op, idx) => {
            return (
                <div
                    style={{border: '1px solid #cfcfcf', borderRadius: 2, width: 336, paddingBottom: 8}}
                    key={op.title}
                >
                    {renderHeader(op, idx)}
                    <div style={{marginLeft: 12}}>
                        <table>
                            {
                                op.children.map((item, idy) => {
                                    if(!checkType(op.type))
                                        item.enable = false

                                    const getChildFontColor = (status, idx, idy, showIndicator) => {
                                        if(status === OPS_STATUS.COMPLETED && !showIndicator)
                                            return successColor
                                        else if(status === OPS_STATUS.COMPLETED && showIndicator)
                                            return errorColor
                                        else
                                            return normalColor
                                    }

                                    const showIndicator = item.showIndicator && item.showIndicator({data: item.result})

                                    return (
                                        <tr key={v4()}>
                                            <div style={{display: 'flex', gap: 4, alignItems: 'center'}}>
                                                <Checkbox
                                                    disabled={isRunning() || !id}
                                                    checked={item.enable}
                                                    onChange={(e) => {
                                                        onCheckedChanged(op.title, item.title, e.target.checked)
                                                    }}
                                                />
                                                <a
                                                    onClick={() => {setSelectedIndex({x: idx, y: idy})}}
                                                    style={{
                                                        color: getChildFontColor(item.status, idx, idy, showIndicator),
                                                        fontWeight: selectedIndex.x === idx && selectedIndex.y === idy ? 'bold' : '',
                                                        flex: 1
                                                    }}
                                                >
                                                    {item.title}
                                                    <span style={{marginLeft: 16}}>
                                                        {showKey && (`(${item.key_text || item.key})`)}
                                                    </span>
                                                </a>
                                                {
                                                    item.status === OPS_STATUS.COMPLETED && showIndicator && (
                                                        <>
                                                            <span style={{color: errorColor}}>
                                                                {/*({item.time.toFixed(1)} s)*/}
                                                            </span>
                                                        </>

                                                    )
                                                }
                                                {
                                                    item.status === OPS_STATUS.CHECKING && activeOperation?.title === item.title && (
                                                        <Spin size={'small'}/>
                                                    )
                                                }
                                                {
                                                    item.status === OPS_STATUS.COMPLETED && !showIndicator && (
                                                        <span style={{color: successColor}}>
                                                            {/*({item.time.toFixed(1)} s)*/}
                                                        </span>
                                                    )
                                                }
                                                {
                                                    item.status === OPS_STATUS.ERROR && (
                                                        <span style={{color: errorColor}}><CloseOutlined /></span>
                                                    )
                                                }
                                            </div>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                    </div>
                </div>
            )
        })
    }

    const renderContent = () => {
        if(selectedIndex.x === -1 && selectedIndex.y === -1) {
            if(summaryPanel)
                return summaryPanel()
            else
                return
        }

        if(_operations.length > 0 && selectedIndex.x < _operations.length && selectedIndex.x >= 0) {
            const child = _operations[selectedIndex.x].children[selectedIndex.y];

            return (
                <>
                    <div style={{height: '100%'}}>
                        <CheckResult
                            data={{
                                ...child.result,
                                key: child.key
                            }}
                            status={child.status}
                            noIssueText={child.noIssueText}
                            settings={settings}
                        />
                    </div>
                </>
            )
        }

        if(summaryPanel)
            return summaryPanel()
    }

    const getOperationTitle = () => {
        if(selectedIndex.x === -1 && selectedIndex.y === -1) {
            if(summaryPanel)
            {
                return `Plan Overviews`
            }
        }

        if(_operations.length > 0 && selectedIndex.x < _operations.length && selectedIndex.x >= 0) {
            const child = _operations[selectedIndex.x].children[selectedIndex.y];
            return `${child.title} ${showKey && (child.key_text)}`
        }

        return `Operations`
    }

    useEffect(() => {
        setOperationTitle({title: getOperationTitle()})
    }, [id, selectedIndex]);

    const nextItem = () => {
        const data = []
        _operations.forEach((ops, idx) => {
            ops.children.forEach((child, idy) => {
                data.push({
                    indexX: idx,
                    indexY: idy,
                    ...child
                })
            })
        })

        let index = data.findIndex(x => x.indexX === selectedIndex.x && x.indexY === selectedIndex.y)
        if(selectedIndex.x === -1 && selectedIndex.y === -1)
           index = -1

        if(index >= -1 && index < data.length) {
            for(let i=index+1; i<data.length; i++) {
                const item = data[i]
                if(item.result?.result && item.result?.result.length > 0) {
                    setSelectedIndex({
                        x: item.indexX,
                        y: item.indexY
                    })
                    return
                }
            }
        }
    }

    const prevItem = () => {
        const data = []
        _operations.forEach((ops, idx) => {
            ops.children.forEach((child, idy) => {
                data.push({
                    indexX: idx,
                    indexY: idy,
                    ...child
                })
            })
        })

        const index = data.findIndex(x => x.indexX === selectedIndex.x && x.indexY === selectedIndex.y)
        if(index > -1 && index > 0) {
            for(let i=index-1; i>=0; i--) {
                const item = data[i]
                if(item.result?.result && item.result?.result.length > 0) {
                    setSelectedIndex({
                        x: item.indexX,
                        y: item.indexY
                    })
                    return
                }
            }
        }

        setSelectedIndex({
            x: -1,
            y: -1
        })
    }

    useEffect(() => {
        const data = []
        _operations.forEach((ops, idx) => {
            ops.children.forEach((child, idy) => {
                data.push({
                    indexX: idx,
                    indexY: idy,
                    ...child
                })
            })
        })

        const first = data.find(x => x.result?.result && x.result?.result.length > 0)
        const last = data.filter(x => (x.indexX > first?.indexX || x.indexY > first?.indexY)).reverse().find(x => x.result?.result && x.result?.result.length > 0)

        let index_data = {}
        if(first && last) {
            index_data = {
                firstError: {x: first.indexX, y: first.indexY},
                lastError: {x: last.indexX, y: last.indexY},
            }
        }
        else if(first && !last) {
            index_data = {
                firstError: {x: first.indexX, y: first.indexY},
                lastError: {x: first.indexX, y: first.indexY},
            }
        }

        setIndexData(index_data)

    }, [_operations]);

    useEffect(() => {
        if(!window.nextImage) {
            window.nextImage = <img src={'/icons/Next.svg'} width={24} height={24} />
            window.nextDisabledImage = <img src={'/icons/Next-Disabled.svg'} width={24} height={24} />
            window.prevImage = <img src={'/icons/Previous.svg'} width={24} height={24} />
            window.prevDisabledImage = <img src={'/icons/Previous-Disabled.svg'} width={24} height={24} />
        }
    }, []);

    const DSUS = ({reverse}) => {
        return (
            <div style={{display: 'flex', alignItems: 'center', height:'100%'}}>
                <ArrowDownOutlined />
                {/*<SortAscendingOutlined />*/}
                <div style={{fontSize: '6pt', display: 'flex', flexDirection: 'column', lineHeight: '8px'}}>
                    {
                        reverse && (
                            <>
                                <text style={{padding: 0}}>{'US'}</text>
                                <text style={{padding: 0}}>{'DS'}</text>
                            </>
                        )
                    }
                    {
                        !reverse && (
                            <>
                                <text style={{padding: 0}}>{'DS'}</text>
                                <text style={{padding: 0}}>{'US'}</text>
                            </>
                        )
                    }
                </div>
            </div>
        )
    }

    const isPrevDisabled = () => {
        if(selectedIndex.x >= 0 || selectedIndex.y >= 0) {
            return false
        }

        if(selectedIndex?.x < indexData?.firstError?.x)
            return true
        else if(selectedIndex?.x === indexData?.firstError?.x && selectedIndex?.y <= indexData?.firstError?.y)
            return true

        return false
    }

    const isNextDisabled = () => {
        if(selectedIndex?.x > indexData?.lastError?.x)
            return true
        else if(selectedIndex?.x === indexData?.lastError?.x && selectedIndex?.y >= indexData?.lastError?.y)
            return true

        return false
    }

    const isRunning = () => {
        return _operations.filter(x => x.children.filter(y => y.status === OPS_STATUS.CHECKING).length > 0).length > 0
    }

    return (
        <>
            <div style={{display: 'flex', width: '100%', alignItems: 'start'}}>
                <Popover
                    placement={'bottomLeft'}
                    trigger={'click'}
                    overlayStyle={{padding: 0, margin: 0}}
                    content={(
                        <div
                            style={{width: 1368}}
                        >
                            <div style={{
                                marginLeft: 5, marginBottom: 4,
                                backgroundColor: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 24,
                            }}>
                                <Checkbox
                                    disabled={isRunning() || !id}
                                    checked={_operations.filter(x => x.children.find(y => y.enable)).length === _operations.length - _operations.filter(x => !checkType(x.type)).length}
                                    onChange={(e) => {
                                        const ops = [..._operations]
                                        ops.forEach(x => {
                                            x.children.forEach(y => {
                                                if (!checkType(x.type)) {
                                                    y.enable = false
                                                }
                                                y.enable = e.target.checked
                                            })
                                        })
                                        set_operations(ops)
                                    }}
                                >
                                    {
                                        _operations.filter(x => x.children.find(y => y.enable)).length === _operations.length - _operations.filter(x => !checkType(x.type)).length ? 'Deselect All' : 'Select All'
                                    }
                                </Checkbox>

                                {
                                    summaryPanel && (
                                        <div className="ant-collapse-item ant-collapse-no-arrow">
                                            <div
                                                onClick={() => {
                                                    setSelectedIndex({x: -1, y: -1})
                                                }}
                                                className="ant-collapse-header"
                                                aria-expanded="false"
                                                aria-disabled="false"
                                                role="button"
                                                tabIndex="0">
                                                <text className="ant-collapse-header-text">
                                                        <span
                                                            style={{fontWeight: selectedIndex.x === -1 && selectedIndex.y === -1 ? 'bold' : ''}}>
                                                            <div>
                                                                Overview (Total Time: {getAllTime()} s)
                                                            </div>
                                                        </span>
                                                </text>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                            <div>
                                <div
                                    style={{display: 'flex', flexWrap: 'wrap', gap: 8}}
                                >
                                    {renderOperations()}
                                </div>
                            </div>
                        </div>
                    )}
                >
                    <Button
                        size={'small'}
                        style={{
                            width: 350,
                            height: 38,
                            fontFamily: 'Segoe UI',
                            fontSize: '9pt',
                            backgroundColor: '#f0f2f5',
                            textAlign: 'start',
                        }}
                    >
                        {isRunning() && <Spin spinning={true}/>}
                        <b>{!isRunning() && getOperationTitle()}</b>
                    </Button>
                </Popover>
                <div
                    style={{
                        backgroundColor: 'white',
                        display: 'flex',
                        alignContent: 'space-between',
                        flex: 1,
                        alignItems: 'center',
                        paddingRight: 8
                    }}
                >
                    <div style={{
                        padding: 3,
                        display: 'flex',
                        height: 38,
                        alignItems: 'center',
                        flex: 1
                    }}>
                        <Button
                            disabled={isPrevDisabled() || isRunning() || !id}
                            icon={<Icon component={() => !isPrevDisabled() ? <PrevLogo/> :
                                <PrevDisabledLogo/>}/>} type={'text'}
                            onClick={prevItem}
                        />
                        <Button
                            disabled={isNextDisabled() || isRunning() || !id}
                            icon={<Icon component={() => (!isNextDisabled() ? <NextLogo/> :
                                <NextDisabledLogo/>)}/>} type={'text'}
                            onClick={nextItem}
                        />
                        <div style={{paddingLeft: 16}}/>
                        {projectSelectorComponent && projectSelectorComponent()}
                        <div style={{paddingLeft: 16}}/>
                        <Popover
                            content={(
                                <div style={{flex: 1}}>
                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: 3,
                                        height: 38,
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        {toolboxLeft}
                                        <Radio.Group
                                            style={{marginLeft: 16}}
                                            options={[
                                                {label: <DSUS reverse={true}/>, value: 'ds'},
                                                {label: <DSUS/>, value: 'us'},
                                            ]}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                setSort({
                                                    sort: val
                                                })
                                            }}
                                            value={sort}
                                            optionType="button"
                                            buttonStyle="solid"
                                            size={'small'}
                                        />
                                        {toolbox}
                                    </div>
                                </div>
                            )}
                        >
                            <Button
                                size={'small'}
                                type={'primary'}
                            >
                                <SettingOutlined/>
                            </Button>
                        </Popover>
                    </div>
                    <div style={{width: 500}}>
                        {tabComponent}
                    </div>
                </div>
            </div>
            <div key={key}>
            {
                    id && (
                        <>
                            <div style={{width: '100%', height: '83.7%'}}>
                                {renderContent()}
                            </div>
                        </>
                    )
                }
            </div>
        </>
    )
}